import _ from '../utils/lodash';

export default {
  setContext (data) {
    context = data || {};
    normalize = _.get(data, 'utils.eventElements.normalize', normalize);
    attrCode = _.get(data, 'utils.eventElements.attrCode', attrCode);
    extra = _.get(data, 'extra', extra);
  },

  getContext () {
    return context;
  },

  get (key) {
    return context[key];
  },

  set (key, value) {
    if (!context) {
      context = {};
    }
    context[key] = value;
  }
};

export var normalize = function normalize () {
};

export var attrCode = {};
export var extra = {};

let context = {};



/** WEBPACK FOOTER **
 ** ./src/services/contextService.js
 **/